import { useCallback } from 'react';

import { createRoot } from 'react-dom/client';

import { FullscreenImageViewer } from '@vlabs/monokit/shared/ui/fullscreen-image-viewer';

import type { ViewPhotoProps } from './types';

export function useFullscreenImageViewer({
  url = undefined,
}: ViewPhotoProps): VoidFunction {
  return useCallback(() => {
    if (!url) return;

    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleClose = (): void => {
      root.unmount();
      container.remove();
    };

    root.render(
      <FullscreenImageViewer
        onClose={handleClose}
        open
        url={url}
      />,
    );
  }, [url]);
}
